import { type ComponentProps } from 'react';
import { BlogsMetadata } from '../../../constants/BlogsMetadata';
import { ClassKidsRecruitment, classKidsRecruitmentStatusText } from '../../../constants/ClassKidsRecruitment';
import { PageUrl } from '../../../constants/PageUrl';
import { SectionId } from '../../../constants/SectionId';
import SectionTitle from '../../class_landing_page/atoms/SectionTitle';
import LinkCard from '../../common/LinkCard';
import styles from './index.module.scss';

const notifications: ComponentProps<typeof LinkCard>[] = [
  {
    title: `キッズコース（${ClassKidsRecruitment.ageRangeText}）${classKidsRecruitmentStatusText()}`,
    description:
      '金曜16:40〜17:50のキッズコースで、モンテッソーリ教具に触れながら集中力や自己肯定感を育みます。入会はいつでも可能です。',
    thumbnailUrl: '/img/classroom.webp',
    href: PageUrl.CLASS_TOP,
  },
  {
    title: 'なるみ・岡村の過ぎるTV で紹介されました！',
    description:
      'テレビ朝日系「なるみ・岡村の過ぎるTV」にて、みらいキッズモンテプリスクールの取り組みをご紹介いただきました。放送内容や当園の教育方針の詳細はこちらからご覧ください。',
    thumbnailUrl: '/img/tv-announcement.png',
    href: PageUrl.TV_LP,
  },
  {
    title: BlogsMetadata.appearsOnRadio202311.title,
    thumbnailUrl: BlogsMetadata.appearsOnRadio202311.thumbnailUrl,
    description: BlogsMetadata.appearsOnRadio202311.description,
    href: BlogsMetadata.appearsOnRadio202311.filePath,
  },
];

export const Notification = () => (
  <section id={SectionId.TOP_NOTIFICATION} className={styles.base}>
    <SectionTitle variant="border">お知らせ</SectionTitle>
    <div className={styles['notifications-wrapper']}>
      {notifications.map(({ title, thumbnailUrl, description, href }) => (
        <LinkCard key={title} title={title} thumbnailUrl={thumbnailUrl} description={description} href={href} />
      ))}
    </div>
  </section>
);
